import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Asset } from '@ess/jg-rule-executor';

@Component({
  selector: 'component-asset-dialog',
  templateUrl: 'asset-dialog.component.html',
  styleUrls: ['./asset-dialog.component.scss'],
  standalone: false,
})
export class AssetDialogComponent {
  constructor(@Inject(MAT_DIALOG_DATA) public data: { asset: Asset }) {
  }
}
